import React from 'react';
import { ShieldLockFill } from 'react-bootstrap-icons';
import { LandingFooter, LandingHeader } from '../components/LandingSiteChrome';
import './LegalPage-new.css';

interface LegalSection
{
    id: string;
    title: string;
    content: React.ReactNode;
}

interface LegalPageProps
{
    eyebrow: string;
    title: string;
    summary: string;
    lastUpdated: string;
    sections: LegalSection[];
    footerNote: string;
}

function scrollToSection(id: string): void
{
    const element = document.getElementById(id);
    if (element)
    {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
}

function LegalPage({ eyebrow, title, summary, lastUpdated, sections, footerNote }: LegalPageProps): React.ReactElement
{
    return (
        <div className="legal-root">
            <LandingHeader />

            <header className="legal-hero">
                <div className="legal-hero-inner">
                    <div>
                        <div className="legal-eyebrow">
                            <ShieldLockFill size={14} />
                            <span>{eyebrow}</span>
                        </div>
                        <h1 className="legal-title">{title}</h1>
                        <p className="legal-summary">{summary}</p>
                    </div>

                    <aside className="legal-meta-card" aria-label="Document details">
                        <p className="legal-meta-label">Last Updated</p>
                        <p className="legal-meta-value">{lastUpdated}</p>
                        <p className="legal-meta-label legal-meta-label--spaced">Applies To</p>
                        <p className="legal-meta-value">
                            AcceliQA web application, customer accounts, uploaded repositories, and generated testing artifacts.
                        </p>
                    </aside>
                </div>
            </header>

            <main className="legal-shell">
                <div className="legal-grid">
                    <aside className="legal-sidebar" aria-label="On this page">
                        <p className="legal-sidebar-title">On this page</p>
                        <ul className="legal-sidebar-list">
                            {sections.map((section) => (
                                <li key={section.id}>
                                    <button
                                        className="legal-sidebar-link"
                                        type="button"
                                        onClick={() => scrollToSection(section.id)}
                                    >
                                        {section.title}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </aside>

                    <div className="legal-content">
                        {sections.map((section) => (
                            <section key={section.id} id={section.id} className="legal-card">
                                <h2 className="legal-card-title">{section.title}</h2>
                                <div className="legal-card-content">{section.content}</div>
                            </section>
                        ))}

                        <div className="legal-footer-note">
                            {footerNote}
                        </div>
                    </div>
                </div>
            </main>

            <LandingFooter />
        </div>
    );
}

export default LegalPage;
